/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  IStaticPageContentMethods,
  StaticPageContentService,
  IRegisterUserMethods,
  RegisterUserService,
  URLService,
  IURLMethods,
} from './plugins';

export type TAgent = IStaticPageContentMethods &
  IRegisterUserMethods &
  IURLMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new RegisterUserService(),
    new URLService(),
  ];
};

export const getAgent = () => {
  return createAgent<TAgent>({
    plugins: getPlugins(),
  });
};
